module.exports = __webpack_public_path__ + "img/my-cards.af42825c.svg";